namespace SP.Data {
    export class Trolley {

        private static trolleys: TrolleyInfo[] = null;

        static async getTrolleyInfos(useCache = true) {
            if (useCache && this.trolleys) return this.trolleys;
            var response = await SP.get<any>("/api/v1/info/trolleyInfos/");
            if (response.status == 200) {
                this.trolleys = response.data as TrolleyInfo[];
                return this.trolleys;
            }
            else await SP.alertX(response.status + ": " + response.msg);
            return null;
        }

        static async getTrolleyInfo(id: number) {
            if (!this.trolleys) {
                await this.getTrolleyInfos();
            }
            return this.trolleys.filter(t => t.id == id)[0];
        }
    }
}